import { useCallback, useEffect, useState } from 'react'

import ReactLowlight from 'react-lowlight'

import { lowlight, importHighlightJsLanguage } from '../common/lib/lowlight.js'

import { CodeCopyButton } from './CodeCopyButton.js'

export interface CodeBlockProps {
  language: string | null
  content: string | JSX.Element | JSX.Element[]
  copyButton?: boolean
}

export const CodeBlock = ({
  language: detectedLanguage,
  content,
  copyButton,
}: CodeBlockProps) => {
  const [codeLanguage, setCodeLanguage] = useState(
    lowlight.registered(detectedLanguage) ? detectedLanguage : null,
  )

  const loadLanguage = useCallback(
    async (language: string) => {
      if (detectedLanguage && !lowlight.registered(language)) {
        await importHighlightJsLanguage(language)
        // force apply new highlight
        setCodeLanguage(lowlight.registered(language) ? language : null)
      }
    },
    [detectedLanguage],
  )

  useEffect(() => {
    loadLanguage(detectedLanguage)
  }, [detectedLanguage, loadLanguage])

  return (
    <div className="relative">
      {copyButton && typeof content === 'string' && (
        <div className="absolute top-2 end-2">
          <CodeCopyButton content={content} />
        </div>
      )}
      <ReactLowlight language={codeLanguage} value={content} />
    </div>
  )
}
